import { InputField } from "./InputField";
import type { UtdoContact } from "../types";
import { toNullableInt, toString } from "../util/converters";

type ContactsEditorProps = {
    contact: UtdoContact;
    validate: (contact: UtdoContact) => any;
    cancel: () => any;
};

export function ContactsEditor(props: ContactsEditorProps) {
    let elId!: HTMLInputElement;
    let elName!: HTMLInputElement;
    let elValue!: HTMLTextAreaElement;
    let elHidden!: HTMLInputElement;
    const cancel = (ev: Event) => {
        ev.preventDefault();
        ev.stopPropagation();
        props.cancel();
    };
    const validate = (ev: Event) => {
        ev.preventDefault();
        ev.stopPropagation();
        const id = toNullableInt(elId.value);
        const name = toString(elName.value);
        const value = toString(elValue.value);
        const hidden = elHidden.checked;
        props.validate({
            id,
            name,
            value,
            sort: 0, // le sort sera ignoré lors des modifications
            hidden,
        });
    };
    return <form onSubmit={validate} autocomplete="off">
            <input ref={elId} type="hidden" value={props.contact.id}/>
            <InputField
                ref={elName}
                type="text"
                id="contact-name"
                label="Nom"
                required
                value={props.contact.name}/>
            <InputField
                ref={elValue}
                type="textarea"
                id="contact-value"
                label="Valeur"
                required
                value={props.contact.value}/>
            <div class="info">
                Vous pouvez protéger des valeurs en les entourant avec&nbsp;<b>{"@{"}</b> ... <b>{"}"}</b>
            </div>
            <InputField
                ref={elHidden}
                type="checkbox"
                id="contact-hidden"
                label="Cacher"
                required
                value={props.contact.hidden}/>
            <div class="actions">
                <input type="submit" value="Enregistrer" class="accent" />
                <button onClick={cancel}>Annuler</button>
            </div>
        </form>;
}